export const quickEntries = [
  {
    id: "entry-channel",
    icon: "ri-door-open-line",
    title: "官网入口",
    desc: "通过官方入口进入，避免误点仿冒页面，是长期稳定的进入方式。",
    tone: "primary",
  },
  {
    id: "entry-address",
    icon: "ri-links-line",
    title: "最新地址",
    desc: "地址可能随域名调整而变化，遇到打不开先确认是否启用了新的访问地址。",
    tone: "accent",
  },
  {
    id: "app",
    icon: "ri-smartphone-line",
    title: "APP 下载",
    desc: "优先从官方渠道或正规应用商店获取安装包，拒绝来路不明的安装文件。",
    tone: "secondary",
  },
  {
    id: "online",
    icon: "ri-book-open-line",
    title: "在线看",
    desc: "不想安装 APP 时，用网页版直接浏览，适合临时阅读与轻量使用。",
    tone: "primary",
  },
];

export const entryChannels = [
  {
    name: "网页版入口",
    traits: "免安装、打开即用、随开随关",
    scene: "临时阅读、电脑端浏览、临时设备",
    note: "以浏览器访问，注意核对域名是否为官方公布地址",
  },
  {
    name: "移动适配页",
    traits: "针对手机屏幕优化的浏览页面",
    scene: "手机浏览器、单手操作、流量有限",
    note: "排版更适配小屏，功能相对精简",
  },
  {
    name: "官方 APP",
    traits: "安装后常驻桌面、支持缓存与推送",
    scene: "长期追更、离线查看、消息提醒",
    note: "务必从官方渠道下载，避免第三方破解包",
  },
  {
    name: "备用 / 镜像地址",
    traits: "主地址不通时的临时访问路径",
    scene: "主地址临时不可用、运营商拦截时",
    note: "仅使用官方公布的备用地址，警惕伪装备用站",
  },
];

export const changeReasons = [
  {
    icon: "ri-global-line",
    title: "域名策略调整",
    desc: "站点可能因运营需要更换域名，旧地址逐步失效，新地址承担访问流量。",
  },
  {
    icon: "ri-shield-cross-line",
    title: "运营商线路拦截",
    desc: "不同网络环境对同一地址的连通性不同，部分宽带或移动网络可能临时无法打开。",
  },
  {
    icon: "ri-server-line",
    title: "解析与服务器变更",
    desc: "域名解析、服务器迁移期间会出现短暂无法访问，通常一段时间后恢复。",
  },
  {
    icon: "ri-user-unfollow-line",
    title: "仿冒站点的干扰",
    desc: "地址变化期常被仿冒站点利用，混淆真实入口，诱导用户填写信息或下载文件。",
  },
];

export const fakeChecklist = [
  "核对域名是否与官方公布的地址完全一致，注意多余字母、连字符或相似字符替换。",
  "警惕要求输入账号密码、支付信息或手机验证码的页面，正规访问不需要额外提交敏感资料。",
  "不下载页面弹窗强推的安装包，安装文件只从官方渠道或正规应用商店获取。",
  "对「网址即将失效，请立即升级 / 下载」之类的高压提示保持警惕。",
  "遇到要求关闭安全软件、扫码付款或跳转到陌生聊天工具的页面，直接退出。",
];

export const guideSteps = [
  {
    no: "01",
    title: "先确认一个可用的官方入口",
    desc: "从官方公布的信息渠道获取入口，而不是从搜索结果的广告位或陌生群聊链接进入。",
  },
  {
    no: "02",
    title: "核对域名再访问",
    desc: "打开前逐字符比对域名，确认没有拼写差异、多余符号或相似字符替换，再继续浏览。",
  },
  {
    no: "03",
    title: "地址打不开时先排查环境",
    desc: "尝试切换网络、刷新页面、清理浏览器缓存，排除本地网络或缓存导致的临时打不开。",
  },
  {
    no: "04",
    title: "确认是否为更换地址",
    desc: "若多个网络都打不开，可能是地址已调整，此时通过官方渠道获取最新地址，而不是随意搜索。",
  },
  {
    no: "05",
    title: "选择网页版或安装 APP",
    desc: "临时使用选网页版；需要长期追更、缓存或提醒时，再从官方渠道安装 APP。",
  },
  {
    no: "06",
    title: "收藏并留存备用方式",
    desc: "把确认过的入口加入书签，并保存官方备用地址，下次遇到地址变化时能快速回到正确入口。",
  },
];

export const appPlatforms = [
  {
    key: "android",
    label: "Android 安卓",
    icon: "ri-android-line",
    points: [
      "优先从正规应用商店或官方公布的下载页面获取安装包。",
      "下载前核对安装包的来源与文件名，避免从陌生网盘、聊天群文件直接安装。",
      "安装时留意系统提示的权限申请，对短信、通讯录、无障碍等无关权限保持警惕。",
      "如系统提示「未知来源应用」，确认来源可靠后再开启对应权限，用完可关闭。",
      "安装后首次打开如出现强制更新或跳转页面，先核对是否为官方界面再操作。",
    ],
  },
  {
    key: "ios",
    label: "iOS 苹果",
    icon: "ri-apple-line",
    points: [
      "优先通过 App Store 搜索官方名称下载，认准开发者信息与下载量。",
      "若官方提供测试版渠道，务必从官方说明的入口进入，不接受他人转发的安装描述文件。",
      "不加装来源不明的「描述文件」或「企业证书」，避免设备被安装非官方应用。",
      "没有可用客户端时，可直接使用网页版，并添加到主屏幕作为轻量替代。",
      "更新时以应用商店提示为准，不通过短信或弹窗链接直接更新。",
    ],
  },
  {
    key: "common",
    label: "通用注意",
    icon: "ri-alert-line",
    points: [
      "任何要求输入支付密码、验证码或银行卡信息的「下载引导」都应当拒绝。",
      "APK、IPA 等安装文件不要从搜索引擎广告或第三方下载站获取。",
      "安装前用安全软件扫描安装包，安装后留意是否出现异常弹窗或后台耗电。",
      "定期检查已安装应用列表，卸载来源不明或长期未使用的应用。",
    ],
  },
];

export const onlinePoints = [
  {
    icon: "ri-flashlight-line",
    title: "打开即用",
    desc: "网页版无需安装，输入可用地址即可浏览，适合临时或临时设备使用。",
  },
  {
    icon: "ri-layout-masonry-line",
    title: "小屏适配",
    desc: "移动适配页针对手机屏幕优化排版，浏览时建议开启浏览器阅读模式减少干扰。",
  },
  {
    icon: "ri-history-line",
    title: "缓存与阅读记录",
    desc: "网页版缓存通常较少，若需要离线查看或保留进度，安装官方 APP 会更方便。",
  },
  {
    icon: "ri-wifi-line",
    title: "网络依赖",
    desc: "网页版每次浏览都依赖网络，网络不稳定时可能出现图片加载缓慢的情况。",
  },
];

export const onlineCompare = [
  { item: "安装成本", web: "无需安装", app: "需下载安装" },
  { item: "离线查看", web: "不支持", app: "支持缓存" },
  { item: "消息提醒", web: "无", app: "支持推送" },
  { item: "更新速度", web: "随网页刷新", app: "客户端同步" },
  { item: "占用空间", web: "几乎为零", app: "占用一定存储" },
  { item: "适合场景", web: "临时浏览", app: "长期追更" },
];

export const faqs = [
  {
    q: "为什么老司机漫画的地址经常变？",
    a: "地址变化通常与域名策略调整、运营商线路差异、服务器与解析变更有关。遇到旧地址打不开时，先排查本地网络，再通过官方渠道获取最新地址，而不是随意搜索或点击来源不明的链接。",
  },
  {
    q: "官网入口和最新地址是一回事吗？",
    a: "不完全一样。官网入口更强调「从官方渠道进入」这一方式，而最新地址是「当前可用的具体网址」。正确做法是：认准官方入口，再从入口获取当下有效的最新地址。",
  },
  {
    q: "不想安装 APP，可以直接在线看吗？",
    a: "可以。网页版免安装、打开即用，适合临时浏览。如果你需要离线缓存、更新提醒或更稳定的阅读体验，再考虑从官方渠道安装 APP。",
  },
  {
    q: "从哪里下载 APP 才安全？",
    a: "优先从正规应用商店或官方公布的下载页面获取。不要从陌生网盘、聊天群文件、搜索引擎广告位下载安装包，安装前留意权限申请是否与功能相关。",
  },
  {
    q: "打不开页面该怎么一步步排查？",
    a: "先刷新页面并清理缓存，再切换网络（如从 Wi-Fi 换成移动数据）重试。如果多个网络都打不开，可能是地址已调整，此时去官方渠道确认最新地址，而不要轻信弹窗里的「立即升级」提示。",
  },
  {
    q: "怎么判断遇到的是不是仿冒页面？",
    a: "重点看域名是否与官方完全一致、页面是否索要账号密码或支付信息、是否强制下载安装包。出现索要敏感信息、要求关闭安全软件或扫码付款等情况，直接退出即可。",
  },
  {
    q: "换设备后怎么快速回到入口？",
    a: "把确认过的入口保存为书签，并把官方备用地址一并留存。换设备登录同一浏览器账号时通常可同步书签，也可把网页版添加到主屏幕作为快捷方式。",
  },
  {
    q: "地址失效后收藏的链接还能用吗？",
    a: "旧的收藏链接可能随地址变化而失效。建议同时保存官方入口页面地址，这样即使具体网址变化，也能从入口快速找到当前有效地址。",
  },
];

export const tips = [
  {
    icon: "ri-bookmark-3-line",
    title: "收藏正确入口",
    desc: "把核对过的官方入口加入浏览器书签，避免每次重新搜索时误入仿冒页面。",
  },
  {
    icon: "ri-smartphone-line",
    title: "添加到主屏幕",
    desc: "网页版可添加到手机主屏幕，像应用一样一键打开，省去反复输入网址。",
  },
  {
    icon: "ri-file-list-3-line",
    title: "留存备用地址",
    desc: "记录官方公布的备用地址，主地址不通时可直接切换，不必临时搜索。",
  },
  {
    icon: "ri-calendar-check-line",
    title: "定期核对一次",
    desc: "每隔一段时间打开一次确认入口可用，遇到变化及时更新自己的收藏。",
  },
  {
    icon: "ri-account-circle-line",
    title: "不在陌生页面登录",
    desc: "只在确认过的官方页面做操作，不向弹窗或第三方页面提交账号与验证码。",
  },
  {
    icon: "ri-delete-bin-6-line",
    title: "清理可疑文件",
    desc: "定期检查下载目录与已安装应用，及时删除来源不明的安装包与应用。",
  },
];

export const navItems = [
  { id: "entry-channel", label: "官网入口" },
  { id: "entry-address", label: "地址变化" },
  { id: "guide", label: "进入步骤" },
  { id: "app", label: "APP 下载" },
  { id: "online", label: "在线看" },
  { id: "faq", label: "常见问题" },
  { id: "tips", label: "防走失" },
];